<template>
  <div>
    <div class="item-box-content" style="padding-bottom:0px;">
      <div class="title-font-style">
        <span>备货信息</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="工单编号：">
              {{
              stockInformation.stockupCode
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备货方式：">
              {{
              stockInformation.stockupType
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="请求备货时间：">
              {{
              stockInformation.createDate | dateFilterNum
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="$route.query.stockUpType === '入库备货'">
          <el-col :span="8">
            <el-form-item label="备货仓库：">
              {{
              stockInformation.storageName || "--"
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仓库地址：">
              {{
              stockInformation.storageAddress || "--"
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">
              {{
              stockInformation.storagePhone || "--"
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="预计发货时间：">
              {{
              stockInformation.deliveryTime | dateFilter
              }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      class="item-box-content"
      style="padding-bottom:0px;"
      v-if="$route.query.stockUpType === '直发备货'"
    >
      <el-form class="details-line-height" style="padding:10px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="发货设置：">{{stockInformation.sendType}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发货人：">
              {{
              stockInformation.sendPeople
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">
              {{
              stockInformation.sendPhone
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收货人：">
              {{
              stockInformation.receivePeople
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收货地址：">
              {{
              stockInformation.receiveAddress
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">
              {{
              stockInformation.receivePhone
              }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { formatDate } from '@/util/tool'
export default {
  props: ['stockInformation'],
  data () {
    return {}
  },
  mounted () { },
  methods: {
    onInitial (val) { }
  },
  filters: {
    dateFilter, dateFilterNum
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd')
  }
}
function dateFilterNum (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style lang="scss" scoped></style>
